import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  MaterialReactTable,
  useMaterialReactTable,
  createMRTColumnHelper,
  type MRT_ColumnDef,
} from 'material-react-table';

import {
  Box,
  Button,
  ListItemIcon,
  MenuItem,
  Tooltip,
  Typography,
  lighten,
} from '@mui/material';

import { LoanManagementTableData } from '../../../interface/ILoanManagement';

import helperIndex from '../../../helpers/index';

import iconView from '../../../assets/visible.png';
import iconEdit from '../../../assets/edit-icon.png';
import iconDelete from '../../../assets/delete.png';
import iconApply from '../../../assets/apply.png';



//example data type


const columnHelper = createMRTColumnHelper<LoanManagementTableData>();

interface LoanManagementTableProps {
  data: LoanManagementTableData[];
}


const LoanManagementTable: React.FC<LoanManagementTableProps> = ({ data }) => {

  const navigate = useNavigate();

  function UpdateLoanButtonClick(param: string) {
    navigate('/Admin/UpdateAdmin/' + param);

  }


  function ApplyLoanClick(memberId: number) {
    navigate('/Admin/CreateLoan/' + memberId);
  }

  function ViewBorrowerDetailsClick(memberId: string) {

  }

  //should be memoized or stable
  const columns = useMemo<MRT_ColumnDef<LoanManagementTableData>[]>(
    () => [
      {
        accessorFn: (row: LoanManagementTableData) => `${row.firstname} ${row.lastname}`,
        id: 'fullName',
        header: 'Full Name',
        enableSorting: true
      },
      {
        accessorKey: 'membershipId',
        header: 'Member ID',
        enableSorting: true,
        sortingFn: (rowA, rowB) => {
          const idA = rowA.original.membershipId;
          const idB = rowB.original.membershipId;
          // Perform numeric comparison
          return Number(idA) - Number(idB);
        }
      },
      {
        // accessorKey: 'amountSubscribed',
        accessorFn: function(row: LoanManagementTableData) {
          return `${helperIndex.formatNumber(row.initialPaidAmount)}`;
      
        },
        header: 'Captial Shares',
        sortingFn: (rowA, rowB) => {
          const firstData = rowA.original.initialPaidAmount;
          const secondData = rowB.original.initialPaidAmount;
          // Perform numeric comparison
          return Number(firstData) - Number(secondData);
        }
      },
      {
        header: 'Actions',
        Cell: ({ renderedCellValue, row }) => (
          <Box className="table-btn">
            <Tooltip title="View Loan">
              <Button
                onClick={() =>
                  navigate('/Admin/BorrowerDetails/' + row.original.memberId)
                }
                className="btn-icon-1"
              >
                <img className='responsive-image' src={iconView} />
              </Button>
            </Tooltip>
            <Tooltip title="Apply Loan">
              <Button className='btn-icon-1'
                onClick={() => ApplyLoanClick(row.original.memberId)}>
                <img className='responsive-image' src={iconApply} />
              </Button>
            </Tooltip>
          </Box>
        )
      }
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    enableColumnActions: false,
    muiTablePaperProps: {
      elevation: 1,
      sx: {
        boxShadow: 'none',
        width: '100%',
        background: 'transparent',
        display: 'grid',

      }
    }
  });

  return <MaterialReactTable table={table} />;
};

export default LoanManagementTable;
